import React, { useEffect } from "react";
import { useCreditBannerStore } from "@/store/slices/creditBannerSlice";
import { useCurrentWorkspace } from "@/store";
import { CREDIT_PROMO_LEARN_MORE_URL } from "./constants";

export const CreditBanner = () => {
    const { isPromoEnabled, isBannerDismissed, dismissBanner, promoStatus, fetchPromoStatus } =
        useCreditBannerStore();
    const currentWorkspace = useCurrentWorkspace();

    // Fetch promo status on mount and when workspace changes
    useEffect(() => {
        fetchPromoStatus(currentWorkspace?.id);
    }, [currentWorkspace?.id, fetchPromoStatus]);

    // Hide banner if promo is disabled, dismissed, or not active
    if (!isPromoEnabled || isBannerDismissed || (promoStatus && !promoStatus.isActive)) {
        return null;
    }

    // Calculate display values from promo status
    const creditLimit = promoStatus?.creditLimit ?? 2000;
    const endDate = promoStatus?.promotion?.endDate
        ? new Date(promoStatus.promotion.endDate).toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
              year: "numeric"
          })
        : "December 31, 2025";

    return (
        <div className="absolute left-1/2 top-8 z-10 hidden -translate-x-1/2 items-center gap-3 whitespace-nowrap rounded-lg bg-white p-3 text-sm font-semibold text-yellow-700 shadow-lg shadow-yellow-500/10 ring-1 ring-yellow-500 md:flex">
            <i className="far fa-gift"></i>
            <span>
                Start building your model now — your first {creditLimit.toLocaleString()} deployment
                credits are on us until {endDate}!
                {CREDIT_PROMO_LEARN_MORE_URL && (
                    <>
                        {" "}
                        <a
                            href={CREDIT_PROMO_LEARN_MORE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-yellow-700 underline"
                        >
                            Learn More
                        </a>
                    </>
                )}
            </span>
            <button
                onClick={dismissBanner}
                className="text-gray-400 transition-colors hover:text-gray-600"
                aria-label="Close banner"
            >
                <i className="far fa-times"></i>
            </button>
        </div>
    );
};
